import {
  Airplane,
  ArrowCounterClockwise,
  ArrowDown,
  ArrowUp,
  DeviceMobile,
  ExclamationMark,
  HandCoins,
  Invoice,
  Lightning,
  Money,
  Password,
  PiggyBank,
  Swap,
  TelevisionSimple,
  WifiHigh,
} from "@phosphor-icons/react";
import { TransactionIcon, TransactionType } from "../@types";

export const getTransactionIcon = (
  type: TransactionType | string
): TransactionIcon => {
  switch (type) {
    case "wallet_transfer":
      return { icon: ArrowUp, color: "#4CAF50" }; // Example: green for wallet transfer
    case "bank_transfer":
      return { icon: ArrowUp, color: "#4CAF50" }; // Blue for bank transfer
    case "debit":
      return { icon: ArrowUp, color: "#4CAF50" }; // Orange for bill payment
    case "bill_payment":
      return { icon: Invoice, color: "#FF9800" }; // Orange for bill payment
    case "airtime_purchase":
      return { icon: DeviceMobile, color: "#FFC107" }; // Yellow for airtime purchase
    case "databundle_purchase":
      return { icon: WifiHigh, color: "#FFC107" }; // Yellow for epin purchase
    case "cabletv_purchase":
      return { icon: TelevisionSimple, color: "#FFC107" }; // Yellow for cable purchase
    case "electricity_purchase":
      return { icon: Lightning, color: "#FFC107" }; // Yellow for electricity purchase
    case "epin_purchase":
      return { icon: Password, color: "#FFC107" }; // Yellow for epin purchase
    case "currency_conversion":
      return { icon: Swap, color: "#9C27B0" }; // Purple for currency conversion
    case "wallet_funding":
      return { icon: ArrowDown, color: "#2196F3" }; // Green for wallet funding
    case "transfer_reversal":
      return { icon: ArrowCounterClockwise, color: "#F44336" }; // Red for transfer reversal
    case "loan_issued":
      return { icon: Money, color: "#673AB7" }; // Deep purple for loan issued
    case "loan_repayment":
      return { icon: HandCoins, color: "#8BC34A" }; // Light green for loan repayment
    case "salary_advance_disbursement":
      return { icon: HandCoins, color: "#00897B" }; // Teal for salary advance credit
    case "aviation_payment":
      return { icon: Airplane, color: "#FF5722" }; // Deep orange for aviation payment
    case "savings":
      return { icon: PiggyBank, color: "#3F51B5" }; // Indigo for savings
    case "Credit":
      return { icon: ArrowDown, color: "#4CAF50" }; // Green for credit
    case "Debit":
      return { icon: ArrowUp, color: "#FF9800" }; // Orange for debit
    default:
      return { icon: ExclamationMark, color: "#9E9E9E" }; // Gray for undefined actions
  }
};
